import angular from 'angular';
import uiRouter from 'angular-ui-router';

import periodListMobileComponent from './periodListMobile.component';

import {ROUTES} from 'common/domain/routes';
import {STATES} from 'common/domain/states';

let periodListMobileModule = angular.module('periodListMobile', [
  uiRouter
])

  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE, {
        url: ROUTES.VACATIONS_ABSENCES.PERIOD_LIST_MOBILE,
        component: 'periodListMobile',
        params: {
          dateToLoad: null,
        },
        data: {
          requiresAuth: true
        }
      });
  })

  .component('periodListMobile', periodListMobileComponent)

  .name;

export default periodListMobileModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/periodListMobile/periodListMobile.js